import { useAppStore } from "@exxatdesignux/product-framework/app-store"
import { brandForProduct } from "@exxatdesignux/product-framework/product-brand"
import { brandColorsEquivalent } from "@exxatdesignux/product-framework/brand-color-match"

import { PRISM_SUITE_PRODUCTS } from "@/lib/prism-suite-products"

/**
 * Retired per-app greens/blues still live in persisted `productBrandColors`.
 * Those overrides flip `<html>` to `theme-custom`, which is why Compliance and
 * Curriculum Mapping showed mint sidebars instead of Prism pink.
 */
export function scrubStalePrismSuiteAccentOverrides(): boolean {
  const state = useAppStore.getState()
  let changed = false

  for (const product of PRISM_SUITE_PRODUCTS) {
    const override = state.productBrandColors[product]
    if (!override?.trim()) continue
    const defaultColor = brandForProduct(product).brandColor
    if (!brandColorsEquivalent(override, defaultColor)) {
      state.setProductBrandColor(product, null)
      changed = true
    }
  }

  return changed
}
